import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  structuredData,
  lang = 'en',
  alternateUrls = {}
}) => {
  const siteUrl = 'https://taealam.bh';
  const fullTitle = title ? `${title} | Taealam` : 'Taealam - Connect with Expert Tutors';
  const defaultImage = `${siteUrl}/logo.png`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={lang} dir={lang === 'ar' ? 'rtl' : 'ltr'} />
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={`${siteUrl}${canonicalUrl}`} />}

      {/* Hreflang Tags for Bilingual SEO */}
      {alternateUrls.en && (
        <link rel="alternate" hrefLang="en" href={`${siteUrl}${alternateUrls.en}`} />
      )}
      {alternateUrls.ar && (
        <link rel="alternate" hrefLang="ar" href={`${siteUrl}${alternateUrls.ar}`} />
      )}
      {alternateUrls.en && (
        <link rel="alternate" hrefLang="x-default" href={`${siteUrl}${alternateUrls.en}`} />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      {canonicalUrl && <meta property="og:url" content={`${siteUrl}${canonicalUrl}`} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:locale" content={lang === 'ar' ? 'ar_BH' : 'en_BH'} />
      {lang === 'en' && <meta property="og:locale:alternate" content="ar_BH" />}
      {lang === 'ar' && <meta property="og:locale:alternate" content="en_BH" />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      {canonicalUrl && <meta property="twitter:url" content={`${siteUrl}${canonicalUrl}`} />}
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage || defaultImage} />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <>
          {Array.isArray(structuredData) ? (
            structuredData.map((schema, index) => (
              <script key={index} type="application/ld+json">
                {JSON.stringify(schema)}
              </script>
            ))
          ) : (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )}
        </>
      )}

      {/* Additional SEO Meta */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />

      {/* Geo Targeting */}
      <meta name="geo.region" content="BH" />
      <meta name="geo.placename" content="Bahrain" />

      {/* Additional Technical Meta */}
      <meta httpEquiv="content-language" content={lang} />
    </Helmet>
  );
};

export default SEO;
